import { MdCheck } from 'react-icons/md'
import styled from 'styled-components'

import { colors } from '../../../../../shared/styles/colors'

export const Title = styled.h1`
  font-family: 'Roboto';
  font-size: 24px;
  font-weight: 700;
  color: ${colors.primary};
`

export const SubTitle = styled.p`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 400;
  color: ${colors.gray7};
`

export const Label = styled.div`
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0em;
  text-align: center;

  color: ${colors.blue};
  padding-bottom: 5px;
`

export const FormSliderStyled = styled.div`
  width: 80%;
`

export const StyledCheck = styled(MdCheck)`
  color: ${colors.white};
  background: ${colors.green};
  font-size: 80px !important;
  padding: 10px 10px 10px 10px;
  border: 3px solid ${colors.green};
  border-radius: 50%;
`
